import { Column } from '@ant-design/plots'
import {
  Modal,
  Card,
  Col,
  Row,
  Statistic,
  Typography,
  DatePicker,
  Button,
  Table,
  Space,
  Tag,
  Image,
  Tooltip,
  Spin,
  Carousel,
} from 'antd'
import React, { useEffect, useState } from 'react'

import userPlaceholder from 'src/assets/images/user-placeholder.png'
import AreaChart from 'src/components/Charts/AreaChart'
import { getMarketplaceByIds } from 'src/api/marketplace'
import { manualFetch } from 'src/utils/fetch'

import {
  CommentOutlined,
  DownloadOutlined,
  LikeOutlined,
  ShareAltOutlined,
} from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import { chartDateType } from 'src/constants'
import { searchRedeemUserReport, fetchMarketPlaces } from 'src/api/reports'
import {
  formatDate,
  formatDateForDisplay,
  formatDateTimeToDDMMYYYY,
  longToTimestamp,
} from 'src/utils/timestamp'
import { getUserPosts } from 'src/api/social'
import { extractTextContent } from 'src/utils/stringUtil'
import { downloadImageById } from 'src/api/image'
import { searchGameReport, searchUserActivityLog } from 'src/api/reports'
import { search, usersUsageMetrics } from 'src/api/user'
import { getAppUsageChart } from 'src/api/dashboard'
import moment from 'moment'
import { formatTimeWithSuffix } from 'src/utils/numberUtils'
import { getMarketPlaceUserMetrics } from 'src/api/marketplace'
import CompletionBarInline from 'src/components/Input/CustomProgressBar'

const { Text, Title } = Typography
const { RangePicker } = DatePicker
interface Marketplace {
  name: string
  id: string
}
interface RedeemUserRecord {
  id: string
  name: string
  email: string
  phone: string
  marketplace?: Marketplace
  redeemedPoints: number
  country: string
}
const UserDetail = () => {
  //chart data
  const [chartData, setChartData] = useState([])

  const [chartGroupBy, setChartGroupBy] = useState(chartDateType[0]?.value)

  const appUsageChartColor = ['#181c84', '#000000', '#5BB2FF']
  const [dateRange, setDateRange] = useState<
    [moment.Moment, moment.Moment] | null
  >(null)
  const startDate = dateRange?.[0]?.format('YYYY-MM-DD') || null
  const endDate = dateRange?.[1]?.format('YYYY-MM-DD') || null
  //user profile
  const [userProfile, setUserProfile] = useState(null)
  const { userName } = useParams()
  const [usageMetricsData, setUsageMetricsData] =
    useState<UserUsageMetricsDto | null>(null)
  const [usageMetricssearchParams, setUsageMetricsSearchParams] = useState({
    userId: '',
  })

  const [redeemUserpageData, setRedeemUserpageData] = useState<{
    data: RedeemUserRecord[]
  }>({ data: [] })
  const [redeemloading, setRedeemLoading] = useState(true)
  const [marketPlaceUsageSearchParams, setMarketPlaceUsageSearchParams] =
    useState({
      userId: '',
      providerCountry: '',
    })
  const [marketPlaceUsageMetrics, setMarketPlaceUsageMetrics] = useState<{
    userId: string
    totalRedeemedPoints: number
  } | null>(null)
  const [products, setProducts] = useState<any[]>([])

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [marketplaceDetails, setMarketplaceDetails] = useState<any>(null)
  const [carouselImages, setCarouselImages] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const [redeemcurrentPage, setRedeemCurrentPage] = useState(1)
  const [redeempageSize, setRedeemPageSize] = useState(10)
  const [redeemtotalRecords, setRedeemTotalRecords] = useState(0)
  const [redemmsearchParams, setRedeemSearchParams] = useState({
    name: '',
    phone: '',
    email: '',
    marketPlaceName: '',
    country: '',
    state: '',
  })
  //game
  const [gameTotalRecords, setGameTotalRecords] = useState(0)
  const [gameCurrentPage, setGameCurrentPage] = useState(1)
  const [gamePageSize, setGamePageSize] = useState(10)
  const [gameloading, setGameLoading] = useState(true)
  const [usageMetricsloading, setUsageMetricsLoading] = useState(true)
  const [gamesearchParams, setGameSearchParams] = useState({
    userName: '',
    page: 0,
    pageSize: 10,
  })
  const [gameData, setGameData] = useState([])
  //social
  const [transformedData, setTransformedData] = useState([])
  const [socialLoading, setSocialLoading] = useState(true)
  const [socialTotalRecords, setSocialTotalRecords] = useState(0)
  const [socialCurrentPage, setSocialCurrentPage] = useState(1)
  const [socialPageSize, setSocialPageSize] = useState(10)
  const [socialSortField, setSocialSortField] = useState('createdOn')
  const [socialSortOrder, setSocialSortOrder] = useState('DESC')
  const [imageLoadErrors, setImageLoadErrors] = useState({})
  const [rowLoading, setRowLoading] = useState<{ [postId: string]: boolean }>(
    {}
  )
  const [activityData, setActivityData] = useState([])
  const [activityLoading, setActivityLoading] = useState(true)
  const [activityTotalRecords, setActivityTotalRecords] = useState(0)
  const [activityCurrentPage, setActivityCurrentPage] = useState(1)
  const [activityPageSize, setActivityPageSize] = useState(10)
  const [activityLogSearchParams, setActivityLogSearchParams] = useState({
    userId: '',
    page: 0,
    pageSize: 10,
  })
  const fetchUserProfile = async () => {
    try {
      const response = await search({
        username: userName,
        isSearchExactMatch: true,
      })

      if (response.data && response.data.length > 0) {
        setUserProfile(response.data[0])
      } else {
        console.warn('No users returned in search response for:', userName)
      }
    } catch (error) {
      console.error('Error fetching user profile:', error)
    }
  }
  const fetchChartData = async (
    startDate,
    endDate,
    groupBy,
    providerCountry,
    userName
  ) => {
    try {
      const response = await getAppUsageChart(
        startDate,
        endDate,
        groupBy,
        providerCountry,
        userName
      )

      if (response && response.length > 0) {
        setChartData(response)
      } else {
        console.warn('No users returned in search response for:', userName)
      }
    } catch (error) {
      console.error('Error fetching user profile:', error)
    }
  }

  useEffect(() => {
    fetchUserProfile()
  }, [userName])
  const fetchUserPostData = async (
    page,
    size,
    userId,
    providerCountry,
    sortField = 'createdOn',
    sortOrder = 'DESC'
  ) => {
    try {
      setSocialLoading(true)
      const response = await getUserPosts(
        page - 1,
        size,
        providerCountry,
        userId,
        false,
        '',
        sortField,
        sortOrder
      )
      const transformedData = await transformData(response.data)
      setTransformedData(transformedData)
      setSocialTotalRecords(response.total_items)
    } finally {
      setSocialLoading(false)
    }
  }
  const getImages = async (attachments, postId) => {
    if (!attachments || attachments.length === 0) return []
    return await Promise.all(
      attachments.map((attachment) =>
        downloadImageById(attachment.attachmentId)
      )
    )
  }
  useEffect(() => {
    let isCancelled = false

    const fetchImagesForRows = async () => {
      const updatedData = await Promise.all(
        transformedData.map(async (item) => {
          if (!item.resourceContents && item.attachments?.length) {
            setRowLoading((prev) => ({ ...prev, [item.id]: true }))
            try {
              const resourceContents = await getImages(
                item.attachments,
                item.id
              )
              if (!isCancelled) {
                return { ...item, resourceContents }
              }
            } catch (e) {
              console.error('Image loading failed', e)
            } finally {
              setRowLoading((prev) => ({ ...prev, [item.id]: false }))
            }
          }
          return item
        })
      )

      if (!isCancelled) {
        setTransformedData(updatedData)
      }
    }

    fetchImagesForRows()

    return () => {
      isCancelled = true
    }
  }, [JSON.stringify(transformedData.map((d) => d.id + d.attachments?.length))])
  const transformData = async (data) => {
    if (!data) return []

    const transformedArray = data.map((item) => ({
      ...item,
      key: item.id,
      username: item.user.username,
      createdOn: longToTimestamp(item.created_on),
      modifiedOn: longToTimestamp(item.modified_on),
      resourceContents: null,
    }))

    return transformedArray
  }
  const columns = [
    {
      title: 'Image',
      dataIndex: 'resourceName',
      key: 'resourceName',
      width: 300,
      sorter: false,
      render: (_, record) => {
        const isLoadingRow = rowLoading[record.id]
        if (isLoadingRow) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Spin size="small" />
            </div>
          )
        }
        if (record.resourceContents && record.resourceContents.length > 0) {
          return (
            <Row gutter={[16, 16]} justify="start">
              {record.resourceContents.map((content, index) => {
                const imageFailed = imageLoadErrors[content]
                return (
                  <Col key={index} span={6}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      {!imageFailed ? (
                        <Image
                          src={content}
                          alt="Attachment"
                          style={{
                            width: '50px',
                            height: '50px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            border: '1px solid #ddd',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                          }}
                          onError={() =>
                            setImageLoadErrors((prev) => ({
                              ...prev,
                              [content]: true,
                            }))
                          }
                        />
                      ) : (
                        <a href={content} download>
                          <Button icon={<DownloadOutlined />} size="small">
                            Download Image
                          </Button>
                        </a>
                      )}
                    </div>
                  </Col>
                )
              })}
            </Row>
          )
        }
        return null
      },
    },
    {
      title: 'Date',
      dataIndex: 'created_on',
      key: 'created_on',
      width: 200,
      render: (dateValue) => {
        return <Text type="secondary">{formatDateForDisplay(dateValue)}</Text>
      },
    },
    {
      title: 'Text',
      dataIndex: 'text',
      key: 'text',
      width: 200,
      sorter: false,
      render: (text) => (
        <Tooltip title={text}>
          {text?.length > 30
            ? extractTextContent(text)?.substring(0, 30) + '...'
            : extractTextContent(text)}
        </Tooltip>
      ),
    },

    {
      title: 'Likes/Comments',
      key: 'engagement',
      render: (_, record) => (
        <Space size="large">
          <span>
            <LikeOutlined style={{ color: 'gray' }} />
            <Text style={{ color: '#3a63ff', marginLeft: 4 }}>
              {record.likes}
            </Text>
          </span>
          <span>
            <CommentOutlined style={{ color: 'gray' }} />
            <Text style={{ color: '#3a63ff', marginLeft: 4 }}>
              {record.comments}
            </Text>
          </span>
          <span>
            <ShareAltOutlined style={{ color: 'gray' }} />
            <Text style={{ color: '#3a63ff', marginLeft: 4 }}>
              {record.shares}
            </Text>
          </span>
        </Space>
      ),
    },
  ]

  const handleModalClose = () => {
    setIsModalVisible(false)
    setMarketplaceDetails(null)
    setCarouselImages([])
  }

  const fetchRedeemUserData = async (page: number, size: number) => {
    setRedeemLoading(true)
    try {
      const response = await searchRedeemUserReport({
        page: page - 1,
        size: size,
        userId: userProfile?.userId,
        statDate: '2020-01-01',
        endDate: '2120-01-01',
      })
      setRedeemUserpageData({ data: response.data })
      setRedeemTotalRecords(response.total_items)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setRedeemLoading(false)
    }
  }
  const fetchGameData = async (searchParams) => {
    setGameLoading(true)
    try {
      const response = await searchGameReport(searchParams)
      setGameData(response.data)
      setGameTotalRecords(response.total_items)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setGameLoading(false)
    }
  }
  const fetchMarketPlaceUserMetrics = async (marketPlaceUsageSearchParams) => {
    try {
      const response = await getMarketPlaceUserMetrics(
        marketPlaceUsageSearchParams
      )
      setMarketPlaceUsageMetrics(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }
  useEffect(() => {
    if (!userProfile) return
    marketPlaceUsageSearchParams.userId = userProfile.userId
    marketPlaceUsageSearchParams.providerCountry = userProfile.providerCountry

    fetchMarketPlaceUserMetrics(marketPlaceUsageSearchParams)
  }, [userProfile])
  const fetchUsageMetrics = async (searchParams) => {
    setUsageMetricsLoading(true)
    try {
      const response = await usersUsageMetrics(searchParams)
      setUsageMetricsData(response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setUsageMetricsLoading(false)
    }
  }
  useEffect(() => {
    if (!userProfile) return
    usageMetricssearchParams.userId = userProfile.userId

    fetchUsageMetrics(usageMetricssearchParams)
  }, [userProfile])
  useEffect(() => {
    if (!userProfile) return
    gamesearchParams.userName = userName
    gamesearchParams.page = gameCurrentPage - 1
    gamesearchParams.pageSize = gamePageSize
    fetchGameData(gamesearchParams)
  }, [userProfile, gameCurrentPage, gamePageSize])
  useEffect(() => {
    if (!userProfile) return
    redemmsearchParams.name = userName
    fetchRedeemUserData(redeemcurrentPage, redeempageSize)
  }, [userProfile, redeemcurrentPage, redeempageSize])
  useEffect(() => {
    if (!userProfile) return
    fetchUserPostData(
      socialCurrentPage,
      socialPageSize,
      userProfile?.userId,
      userProfile?.providerCountry,
      socialSortField,
      socialSortOrder
    )
  }, [
    socialPageSize,
    socialCurrentPage,
    userProfile,

    socialSortField,
    socialSortOrder,
  ])

  useEffect(() => {
    if (!userProfile) return

    fetchChartData(
      startDate,
      endDate,
      chartGroupBy,
      userProfile?.providerCountry,
      userProfile?.userName
    )
  }, [userProfile, startDate, endDate])
  useEffect(() => {
    if (!userProfile) return
    activityLogSearchParams.userId = userProfile.userId
    activityLogSearchParams.page = activityCurrentPage - 1
    activityLogSearchParams.pageSize = activityPageSize
    fetchActivityLogData(activityLogSearchParams)
  }, [userProfile, activityCurrentPage, activityPageSize])
  const handleRedeemTableChange = (pagination: any) => {
    setRedeemCurrentPage(pagination.current)
    setRedeemPageSize(pagination.pageSize)
  }
  const handleGameTableChange = (pagination: any) => {
    setGameCurrentPage(pagination.current)
    setGamePageSize(pagination.pageSize)
  }
  const handleActivityTableChange = (pagination: any) => {
    setActivityCurrentPage(pagination.current)
    setActivityPageSize(pagination.pageSize)
  }
  const handleSocialTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination
    setSocialCurrentPage(current)
    setSocialPageSize(pageSize)

    let sortField = 'createdOn'
    let sortOrder = 'DESC'

    if (sorter?.field === 'createdOn' || sorter?.field === 'modifiedOn') {
      sortField = sorter.field
      sortOrder = sorter.order === 'ascend' ? 'ASC' : 'DESC'
    }

    setSocialSortField(sortField)
    setSocialSortOrder(sortOrder)
  }
  const fetchActivityLogData = async (searchParams) => {
    setActivityLoading(true)
    try {
      const response = await searchUserActivityLog(searchParams)
      setActivityData(response.data)
      setActivityTotalRecords(response.total_items)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setActivityLoading(false)
    }
  }

  const handleMarketplaceClick = async (marketPlaceName: string) => {
    try {
      const product = products.find((p) => p.name === marketPlaceName)
      if (!product) {
        console.warn('Marketplace not found:', marketPlaceName)
        return
      }

      setLoading(true)
      setIsModalVisible(true)

      const marketResponse = await getMarketplaceByIds([product.id])
      const item = marketResponse?.data?.[0]

      if (item) {
        const downloadedImages = await Promise.all(
          (item.images || []).map(
            async (imgUrl: string) => await fetchImage(imgUrl)
          )
        )
        setCarouselImages(downloadedImages)
        setMarketplaceDetails(item)
      } else {
        setMarketplaceDetails(null)
      }

      setLoading(false)
    } catch (error) {
      console.error('Error fetching marketplace details:', error)
      setLoading(false)
    }
  }
  const fetchProducts = async () => {
    try {
      const response = await fetchMarketPlaces()
      setProducts(response)
    } catch (error) {
      console.error('Error fetching products:', error)
    }
  }

  useEffect(() => {
    fetchProducts()
  }, [])

  const fetchImage = async (url: string) => {
    const response = await manualFetch(url, { headers: { accept: 'image/*' } })
    const imageBlob = await response.blob()
    return URL.createObjectURL(imageBlob)
  }

  return (
    <div className="user-detail">
      <div className="user-overview">
        <Row gutter={20}>
          <Col span={4}>
            <Card
              hoverable
              style={{ width: '100%' }}
              cover={<Image src={userPlaceholder} />}
            />
          </Col>
          <Col span={6} className="user-detail">
            <Title level={2}>{userProfile?.userName}</Title>
            <Text className="sub-text-grey" type="secondary">
              Date of Join:{' '}
              {formatDateForDisplay(userProfile?.createdOn?.substring(0, 10))}
            </Text>
            <CompletionBarInline percent={userProfile?.completionPercent} />

            <Card className="points-wrap">
              <Statistic
                title="No. of Games Played"
                value={usageMetricsData?.gameCount}
                valueStyle={{ color: '#5b60ff' }}
              />
            </Card>
            <Card className="points-wrap">
              <Statistic
                title="All Time Total Points"
                value={userProfile?.points}
                suffix="pts"
              />
            </Card>
            <Card className="points-wrap">
              <Statistic
                title="Redeemed Points"
                value={marketPlaceUsageMetrics?.totalRedeemedPoints ?? 0}
                suffix="pts"
              />
            </Card>
          </Col>
          <Col span={12} offset={2}>
            <Card className="chart-wrap-user">
              <div className="user-filter-data">
                <Button
                  className="btn-primary tab-btn"
                  size="large"
                  type="primary"
                >
                  All Time
                </Button>
                <RangePicker
                  size="large"
                  onChange={(dates) => {
                    if (dates && dates.length === 2) {
                      setDateRange(dates as [moment.Moment, moment.Moment])
                    }
                  }}
                />
              </div>
              <AreaChart
                data={chartData}
                colors={appUsageChartColor}
                chartHeight={200}
              />
            </Card>
          </Col>
        </Row>
      </div>

      <div>
        <Row gutter={25} className="features-time-wrap">
          <Col span={4}>
            <Card>
              <Statistic
                title="Casual Games"
                formatter={() => (
                  <span style={{ color: '#3A63FF' }}>
                    {formatTimeWithSuffix(
                      usageMetricsData?.gameUsageDuration || 0
                    )}
                  </span>
                )}
              />
            </Card>
          </Col>
          <Col span={4}>
            <Card>
              <Statistic
                title="Maze"
                formatter={() => (
                  <span style={{ color: '#3A63FF' }}>
                    {formatTimeWithSuffix(
                      usageMetricsData?.mazeUsageDuration || 0
                    )}
                  </span>
                )}
              />
            </Card>
          </Col>
          <Col span={4}>
            <Card>
              <Statistic
                title="Metaverse"
                formatter={() => (
                  <span style={{ color: '#3A63FF' }}>
                    {formatTimeWithSuffix(
                      usageMetricsData?.metaverseUsageDuration || 0
                    )}
                  </span>
                )}
              />
            </Card>
          </Col>
          <Col span={4}>
            <Card>
              <Statistic
                title="Treasure"
                formatter={() => (
                  <span style={{ color: '#3A63FF' }}>
                    {formatTimeWithSuffix(
                      usageMetricsData?.treasureHunterUsageDuration || 0
                    )}
                  </span>
                )}
              />
            </Card>
          </Col>
          <Col span={4}>
            <Card>
              <Statistic
                title="Social"
                formatter={() => (
                  <span style={{ color: '#3A63FF' }}>
                    {formatTimeWithSuffix(
                      usageMetricsData?.socialUsageDuration || 0
                    )}
                  </span>
                )}
              />
            </Card>
          </Col>
        </Row>
      </div>

      <div className="user-activity">
        <Row gutter={25}>
          <Col span={10}>
            <Card className="list-card">
              <Title level={4}>Redeem Point Status</Title>
              <Table
                className="table-sorting"
                rowKey="id"
                dataSource={redeemUserpageData.data}
                loading={redeemloading}
                pagination={{
                  current: redeemcurrentPage,
                  pageSize: redeempageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '100'],
                  total: redeemtotalRecords,
                }}
                onChange={handleRedeemTableChange}
              >
                <Column
                  dataIndex="marketPlaceName"
                  title="Marketplace Name"
                  render={(marketPlaceName: string, record: any) => (
                    <a
                      style={{
                        color: 'blue',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleMarketplaceClick(marketPlaceName)}
                    >
                      <Typography.Text style={{ color: '#0682fa' }}>
                        {marketPlaceName}
                      </Typography.Text>
                    </a>
                  )}
                />
                <Column dataIndex="redeemedPoints" title="Points" />
                <Column dataIndex="createdOn" title="Date" />
              </Table>
            </Card>
          </Col>
          <Col span={14}>
            <Card className="list-card">
              <Title level={4}>Social History</Title>
              <Table
                dataSource={transformedData}
                columns={columns}
                rowClassName={(record) =>
                  record.text_bad_content || record.image_bad_content
                    ? 'bad-content-row'
                    : ''
                }
                pagination={{
                  current: socialCurrentPage,
                  pageSize: socialPageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '100'],
                  total: socialTotalRecords,
                }}
                onChange={handleSocialTableChange}
              />
            </Card>
          </Col>
        </Row>
      </div>
      <div className="user-activity-log" style={{ marginBottom: 20 }}>
        <Row gutter={25}>
          <Col span={10}>
            <Card className="list-card">
              <Title level={4}>Activity Log</Title>

              <Table
                dataSource={activityData}
                pagination={{
                  current: activityCurrentPage,
                  pageSize: activityPageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '100'],
                  total: activityTotalRecords,
                }}
                onChange={handleActivityTableChange}
              >
                <Column dataIndex="eventName" title="Name" />

                <Column
                  dataIndex="eventDuration"
                  title="Duration"
                  render={(text) =>
                    text === 0 ? <span></span> : <span>{text} sec</span>
                  }
                />
                <Column
                  dataIndex="eventDate"
                  title="Date"
                  render={(text) => (
                    <Text type="secondary">
                      {formatDateTimeToDDMMYYYY(text)}
                    </Text>
                  )}
                />
              </Table>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="user-game-activity">
        <Row>
          <Col span={24}>
            <Card className="list-card">
              <Title level={4}>Game Activity Log</Title>

              <Table
                dataSource={gameData}
                pagination={{
                  current: gameCurrentPage,
                  pageSize: gamePageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ['10', '25', '50', '100'],
                  total: gameTotalRecords,
                }}
                onChange={handleGameTableChange}
              >
                <Column dataIndex="gameTitle" title="Game Name" />

                <Column
                  title="Device"
                  dataIndex="deviceType"
                  key="deviceType"
                />
                <Column
                  dataIndex="eventDuration"
                  title="Duration"
                  render={(text) => <span>{text} sec</span>}
                />
                <Column
                  dataIndex="eventDate"
                  title="Date"
                  render={(text) => (
                    <Text type="secondary">
                      {formatDateTimeToDDMMYYYY(text)}
                    </Text>
                  )}
                />
              </Table>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={null}
        title={marketplaceDetails?.name || 'Marketplace Details'}
        centered
        width={600}
      >
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Spin size="large" />
          </div>
        ) : marketplaceDetails ? (
          <div style={{ textAlign: 'center' }}>
            {carouselImages.length > 0 ? (
              <Carousel
                autoplay
                dots
                style={{ maxWidth: 400, margin: '0 auto' }}
              >
                {carouselImages.map((img, index) => (
                  <div key={index}>
                    <Image
                      src={img}
                      alt={`marketplace-${index}`}
                      style={{
                        maxHeight: '300px',
                        objectFit: 'contain',
                        margin: '0 auto',
                        borderRadius: 8,
                      }}
                    />
                  </div>
                ))}
              </Carousel>
            ) : (
              <p>No images available</p>
            )}
            <p style={{ marginTop: 16 }}>{marketplaceDetails?.description}</p>
          </div>
        ) : (
          <p>This marketplace has been deleted.</p>
        )}
      </Modal>
    </div>
  )
}

export default UserDetail
